import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { GridComponent,SelectionSettingsModel, ToolbarItems, PageSettingsModel } from '@syncfusion/ej2-angular-grids';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { GastoService, MenuFuncionService, MonedaService, AlicuotaIvaService, TenantService, ServicioGastoService, ComunidadService, UnidadFuncionalService, TipoMovimientoService } from '../../../../src/app/shared/services';

import { MenuFuncionCodes, Moneda, SearchAlicuotaIvaRequest, SearchMonedaRequest, AlicuotaIva, TipoGasto, DialogConfirmRequest, SaveGastoFromDocumentRequestDto, TipoMovimiento, SearchTipoMovimientoRequest, DialogCargaMovimientoItem, GastoAdjunto, LocalStorageKeys, TenantFeatureFlags, DialogConfirmResponse } from '../../../../src/app/shared/model';
import { SaveGastoRequestDto, SearchServicioGastoRequest, Comunidad, SearchComunidadRequest, SearchUnidadFuncionalRequest, UnidadFuncional, ComunidadTiposGastos } from '../../../../src/app/shared/model';

import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';

@Component({
  selector: 'app-gastoDesdeDocumento',
  templateUrl: './gastoDesdeDocumento.component.html',
  styles: []
})

export class GastoDesdeDocumentoComponent implements OnInit {

  @ViewChild('deudasGrid')
  public deudasGrid: GridComponent;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isMonedaSearching: boolean = false;
  isAlicuotaIvaSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isUnidadFuncionalSearching: boolean = false;
  isTipoGastoComunidadSearching: boolean = false;
  isTipoMovimientoSearching: boolean = false;

  isFileAttaching: boolean = false;
  isResetting: boolean = false;
  isAnalyzing: boolean = false;
  isGastoDeudaSearching: boolean = false;
  isAttachmentSearching: boolean = false;
  hasAnalyzed: boolean = false;

  esGastoComunidad: boolean = false;
  esGastoUf: boolean = false;

  canView: boolean = false;
  canAdd: boolean = false;
  canEditUf: boolean = false;
  canEditComunidad: boolean = false;

  msgError: string = "";
  item: any = { ComunidadId: null, Adjuntos: [] };

  comunidadList: Comunidad[];
  unidadFuncionalList: UnidadFuncional[];
  comunidadTipoGastoList: ComunidadTiposGastos[];
  alicuotaIvaList: AlicuotaIva[];
  monedaList: Moneda[];
  tipoGastoList: TipoGasto[];
  categoriaList: any[];
  tipoMovimientoList: TipoMovimiento[];

  tenantFeatureFlags: TenantFeatureFlags;

  totalPorPagar: number = 0;
  public totalesSeleccionados: any[] = [];

  montoTotal: number = 0;

  public deudaSelectionOptions?: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private router: Router,
    private menuService: MenuFuncionService,
    private comunidadService: ComunidadService,
    private unidadFuncionalService: UnidadFuncionalService,
    private monedaService: MonedaService,
    private alicuotaIvaService: AlicuotaIvaService,
    private servicioGastoService: ServicioGastoService,
    private tipoMovimientoService: TipoMovimientoService,
    private tenantService: TenantService,
    private gastoService: GastoService
  ) {
    this.deudaSelectionOptions = { persistSelection: true, type: 'Multiple', checkboxOnly: true };
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.gastoService.clearTempFolder().subscribe(data => {
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    })

    this.menuService.checkMenuPadre(MenuFuncionCodes.GASTO).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canView = data.Result.some(x => x == MenuFuncionCodes.GASTO_ANALISIS_DOCUMENTO_MASIVO);
            if (!this.canView) {
              this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
              this.onCancel();
              return false;
            }

            this.canAdd = data.Result.some(x => x == MenuFuncionCodes.GASTO_ADD);
            this.canEditComunidad = data.Result.some(x => x == MenuFuncionCodes.GASTO_ASOCIAR_COMUNIDAD);
            this.canEditUf = data.Result.some(x => x == MenuFuncionCodes.GASTO_ASOCIAR_UF);

            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.getComunidades();

    if (this.canEditComunidad && !this.canEditUf) {
      this.loadComunidadView();
    }
    else if(this.canEditUf && !this.canEditComunidad) {
        this.loadUfView();
    }

    if (this.hasAnalyzed && this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      for (var i=0; i<this.item.Adjuntos.length; i++) {
        this.item.Adjuntos[i].TipoGastoId = null;
        this.item.Adjuntos[i].TipoGastoList = null;
        this.item.Adjuntos[i].ServicioGastoId = null;
        this.item.Adjuntos[i].ComunidadTipoGastoServicioList = null;
        this.item.Adjuntos[i].AlicuotaIvaId = null;
      }
    }
  }

//#region Comunidad

  loadComunidadView() {
    this.esGastoComunidad = true;
    this.esGastoUf = false;

    this.item.ComunidadId = null;
  }

  getComunidades() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, cId, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      this.comunidadList = data?.result;

      // if (this.canAdd && this.item != null && this.item.ComunidadId != null && this.item.ComunidadId > 0)
      //   this.comunidadId = this.comunidadList?.find(f => f.Id == this.item.ComunidadId)?.Id;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  onComunidadSelect() {
    if (this.item != null && this.item.ComunidadId != null && this.item.ComunidadId > 0) {
      if (this.esGastoUf)
        this.searchUfs();

      this.getTiposGastosByComunidad();
      this.getAlicuotaIva();
      this.getTiposMovimientos();
    }
  }

  getErrorComunidad() {
    return this.item?.ComunidadId == null || this.item.ComunidadId <= 0 ? 'El campo es obligatorio' : '';
  }

  getTiposGastosByComunidad() {
    this.isTipoGastoComunidadSearching = true;
    this.comunidadService.getTiposGasto(this.item.ComunidadId).subscribe(data => {
      this.isTipoGastoComunidadSearching = false;
      this.comunidadTipoGastoList = data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoGastoComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

//#endregion

//#region UFs

  loadUfView() {
    this.esGastoUf = true;
    this.esGastoComunidad = false;

    this.item.ComunidadId = null;
  }

  searchUfs() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    var r = new SearchUnidadFuncionalRequest(null, null, true, "Codigo", null, null, null, null, null, cId, this.item.ComunidadId, null, true);
    this.isUnidadFuncionalSearching = true;

    this.unidadFuncionalService.search(r).subscribe(data => {
      this.isUnidadFuncionalSearching = false;
      if (data != null)
        this.unidadFuncionalList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isUnidadFuncionalSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

//#endregion

  isProcessing() {
    return (this.isSearching || this.isAnalyzing || this.isSaving || this.isResetting);
  }

  getMonedas() {
    var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(r).subscribe(data => {
      this.isMonedaSearching = false;
      this.monedaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getTiposMovimientos() {
    if (!this.tenantFeatureFlags?.HabilitarControlCaja)
      return false;

    var r = new SearchTipoMovimientoRequest(null, null, true, "Nombre", null, null, -1, null, true);
    this.isTipoMovimientoSearching = true;

    this.tipoMovimientoService.search(r).subscribe(data => {
      this.isTipoMovimientoSearching = false;
      this.tipoMovimientoList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoMovimientoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  onTipoGastoComunidadSelect(item: any) {
    item.ComunidadTipoGastoServicioList = null;
    item.ServicioGastoId = null;

    if (item?.TipoGastoId != null && item.TipoGastoId > 0) {
      this.loadComunidadTipoGastoServicios(item);
    }
  }

  loadComunidadTipoGastoServicios(item: any) {
    var r = new SearchServicioGastoRequest(null, null, true, "Nombre", null, null, null, item.TipoGastoId, true);
    item.IsComunidadTipoGastoServicioSearching = true;

    this.servicioGastoService.search(r).subscribe(data => {
      item.IsComunidadTipoGastoServicioSearching = false;
      item.ComunidadTipoGastoServicioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      item.IsComunidadTipoGastoServicioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getAlicuotaIva() {
    this.isAlicuotaIvaSearching = true;
    var r = new SearchAlicuotaIvaRequest(null, null, true, "Nombre", null, null, null, null, true);

    this.alicuotaIvaService.search(r).subscribe((data)=>{
      this.isAlicuotaIvaSearching = false;
      this.alicuotaIvaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isAlicuotaIvaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  onAlicuotaIvaSelect(item: any) {
    this.calcularImportes(item);
  }

  onMonedaSelect(item: any) {
    item.MonedaId = item.Moneda?.Id;
    this.calcularTotalPorPagar();
  }

  getErrorUnidadFuncionalId(item: any) {
    return item.UnidadFuncionalId == null || item.UnidadFuncionalId <= 0 ? 'El campo es obligatorio' : '';
  }

  getErrorFechaGasto(item: any) {
    return item.FechaGasto == null || item.FechaGasto.length == 0 ? 'El campo es obligatorio' : '';
  }

  getErrorFechaVencimiento(item: any) {
    return item.FechaVencimiento == null || item.FechaVencimiento.length == 0 ? 'El campo es obligatorio' : '';
  }

  getErrorTipoGastoId(item: any) {
    return item.TipoGastoId == null || item.TipoGastoId <= 0 ? 'El campo es obligatorio' : '';
  }

  getErrorServicioGastoId(item: any) {
    return item.ServicioGastoId == null || item.ServicioGastoId <= 0 ? 'El campo es obligatorio' : '';
  }

  getErrorDetalle(item: any) {
    if (item.Detalle == null || item.Detalle.length == 0)
      return 'El campo es obligatorio';
    if (item.Detalle?.length > 100)
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorMonedaId(item: any) {
    return item.Moneda?.Id == null || item.Moneda?.Id <= 0 ? 'El campo es obligatorio' : '';
  }

  getErrorImporteBase(item: any) {
    return item.ImporteBase == null || item.ImporteBase < 0 ? 'El campo es obligatorio' : '';
  }

  getErrorImporte(item: any) {
    return item.Importe == null || item.Importe < 0 ? 'El campo es obligatorio' : '';
  }

  // getErrorImportePercepciones(item: any) {
  //   return item.ImportePercepciones == null || item.TipoGastoId <= 0 ? 'El campo es obligatorio' : '';
  // }

  getErrorAlicuotaIvaId(item: any) {
    return item.AlicuotaIvaId == null || item.AlicuotaIvaId <= 0 ? 'El campo es obligatorio' : '';
  }

  getErrorObservacion(item: any) {
    return item.Observacion?.length > 300 ? 'Límite de 300 caracteres alcanzado' : '';
  }

  getErrorTipoMovimientoId(item: any) {
    return item.TipoMovimientoId == null || item.TipoMovimientoId <= 0 ? 'El campo es obligatorio' : '';
  }

  getErrorCantidadCuotas(item: any) {
    return item.CantidadCuotas == null || item.CantidadCuotas <= 0 ? 'El campo es obligatorio' : '';
  }

  getErrorFechaInicioCuota(item: any) {
    return item.FechaInicioCuota == null ? 'El campo es obligatorio' : '';
  }

  getErrorDiasRepeticionCuotas(item: any) {
    return item.DiasRepeticionCuotas == null || item.DiasRepeticionCuotas < 0 ? 'El campo es obligatorio' : '';
  }

  getErrorPorcentajeAjusteCuota(item: any) {
    return item.PorcentajeAjusteCuota == null || item.PorcentajeAjusteCuota < 0 || item.PorcentajeAjusteCuota > 100 ? 'El campo es obligatorio y con valor entre 0% y 100%' : '';
  }

  onAnalizar() {
    var r = new SaveGastoFromDocumentRequestDto(this.item.Adjuntos?.map(s => s.UrlDocumento));
    this.isAnalyzing = true;

    this.gastoService.generarDesdeDocumentos(r).subscribe(data => {
      this.isAnalyzing = false;
      if (data != null && data.Success && data.Result != null) {
        this.hasAnalyzed = true;
        this.item.Adjuntos = data.Result.Gastos;

        this.calcularTotalPorPagar();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isAnalyzing = false;
      this.sharedFunctions.handleError(err, true);
    })

    this.getMonedas();
  }

  onGuardar() {

    if (this.item.Adjuntos == null || this.item.Adjuntos.length == 0) {
      this.sharedFunctions.showMessage("Debe leer al menos un archivo para continuar con la operación", "Error");
      return false;
    }

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(
        "Confirmación de Operación",
        "¿Seguro que desea generar los " + (this.item?.Adjuntos?.length ?? 0) + " gastos?",
        "Sí",
        "No"
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.doGeneracionDeuda();
      }
    });
  }

  doGeneracionDeuda() {

    var r: SaveGastoRequestDto[] = [];

    for (var i=0; i<this.item.Adjuntos.length; i++) {

      if (this.item.Adjuntos[i].CuentaImputada != null)
        this.item.Adjuntos[i].CuentaImputada.MonedaId = (this.item.Adjuntos[i].MonedaId ?? 0);

      if (this.item.Adjuntos[i].CuentaDetalle != null)
        this.item.Adjuntos[i].CuentaDetalle.MonedaId = (this.item.Adjuntos[i].MonedaId ?? 0);

      var p = new SaveGastoRequestDto(
        0,
        this.item.Adjuntos[i].TipoGastoId,
        this.item.Adjuntos[i].ServicioGastoId,
        this.item.Adjuntos[i].FechaGasto,
        this.item.Adjuntos[i].FechaVencimiento,
        this.item.Adjuntos[i].FechaVencimiento,
        this.item.Adjuntos[i].Detalle,
        this.item.Adjuntos[i].Observacion,
        this.item.Adjuntos[i].MonedaId,
        this.item.Adjuntos[i].AlicuotaIvaId,
        this.item.Adjuntos[i].ImporteBase,
        this.item.Adjuntos[i].ImporteBase,
        true,
        null,
        (this.esGastoUf ? null : this.item.ComunidadId),
        (this.esGastoUf ? this.item.Adjuntos[i].UnidadFuncionalId : null),
        false,
        0,

        [ new GastoAdjunto(0, "", this.item.Adjuntos[i].UrlDocumento, false) ],

        [
          new DialogCargaMovimientoItem(
            this.item.Adjuntos[i].TipoMovimientoId,
            this.item.Adjuntos[i].Importe,
            "",
            this.item.Adjuntos[i].CantidadCuotas,
            this.item.Adjuntos[i].FechaInicioCuota,
            this.item.Adjuntos[i].DiasRepeticionCuotas,
            this.item.Adjuntos[i].PorcentajeAjusteCuota,
            this.item.Adjuntos[i].AplicarAjusteIncremental,
            false,
            null,
            null
          )
        ]
      );

      r.push(p);
      console.log('doGeneracionDeuda request: ', r);
    }

    this.isSaving = true;
    this.gastoService.generarGastos(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result) {
        this.mostrarConfirmacionCierre();
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  mostrarConfirmacionCierre() {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(
        "Gasto Generado Exitosamente!",
        "Se guardaron correctamente los datos. ¿Desea cargar nuevos gastos?",
        "Sí",
        "No"
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted)
        this.sharedFunctions.reloadCurrentRoute();
      else
        this.onCancel();
    });
  }

  onCancel() {
    this.location.back();
  }

  onClean() {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(
        "Confirmación de Operación",
        "Se perderán todos los cambios no guardados hasta el momento. ¿Seguro que desea iniciar nuevamente la operación?",
        "Sí",
        "No"
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.isResetting = true;
        this.gastoService.clearTempFolder().subscribe(data => {
          this.isResetting = false;
          this.sharedFunctions.reloadCurrentRoute();
        },
        (err: HttpErrorResponse) => {
          this.isResetting = false;
          this.sharedFunctions.handleError(err);
          this.sharedFunctions.reloadCurrentRoute();
        })
      }
    });
  }

  onImporteBaseChange(item: any) {
    // this.formGroup.get("ImporteBase")?.markAsTouched();
    this.calcularImportes(item);
  }

  calcularImportes(item: any) {
    var importeBase = parseFloat((item.ImporteBase ?? 0));
    var importePercepciones = parseFloat((item.ImportePercepciones ?? 0));

    var alicuota = this.alicuotaIvaList?.find(f => f.Id == item.AlicuotaIvaId);
    if (alicuota != null && alicuota.Id > 0)
      item.ImporteAlicuotaIva = importeBase * (alicuota.Porcentaje / 100);
    else
      item.ImporteAlicuotaIva = 0;

    item.Importe = importeBase + (item.ImporteAlicuotaIva ?? 0) + (importePercepciones * (item.CantidadCuotas ?? 1));
    item.ImporteCuota = (item.Importe * (1 + ((item.PorcentajeAjusteCuota ?? 0) / 100))) / (item.CantidadCuotas ?? 1);

    this.calcularTotalPorPagar();
  }

  calcularTotalPorPagar() {
    this.totalesSeleccionados = [];

    if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      for (var i=0; i<this.item.Adjuntos.length; i++) {
        var adjunto = this.item.Adjuntos[i];
        var itemKey = (adjunto.Moneda?.Codigo ?? "?");

        var index = this.totalesSeleccionados.findIndex(v => v.key == itemKey);
        if (index == null || index < 0) {
          this.totalesSeleccionados.push({ key: itemKey, value: 0 });
          index = this.totalesSeleccionados.length - 1;
        }

        this.totalesSeleccionados[index].value += parseFloat(adjunto.Importe);
      }
    }
  }

  openAdjuntos(item: any) {
    if (item != null && item.Adjuntos != null && item.Adjuntos.length > 0) {
      for (var i=0; i<item.Adjuntos.length; i++) {
        if (item.Adjuntos[i].ArchivoBase64 != null)
          window.open(item.Adjuntos[i].ArchivoBase64);
      }
    }
    else {
      this.sharedFunctions.showMessage("No hay archivos adjuntos para visualizar", "Error");
      this.deudasGrid.refresh();
    }
  }

  onFileAttachedDelete(item: any) {
    if (item.Id > 0)
      this.onExistingFileAttachedDelete(item);
    else
      this.onNewFileAttachedDelete(item);
  }

  onExistingFileAttachedDelete(item: any) {
    if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      var index = this.item.Adjuntos.findIndex(f => f.Id == item.Id);

      if (index >= 0)
        this.item.Adjuntos.splice(index, 1);
    }
  }

  onNewFileAttachedDelete(item: any) {
    if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      var index = this.item.Adjuntos.findIndex(f => f.NombreDocumento == item.NombreDocumento);

      if (index >= 0)
        this.item.Adjuntos.splice(index, 1);
    }
  }

  onNewFileAttach(event: any) {
    if (event?.target?.files != null && event.target.files.length > 0) {
      var fileList = event.target.files;

      if (this.item.Adjuntos == null)
        this.item.Adjuntos = [];

      for (var i=0; i<fileList.length; i++) {
        if (this.item.Adjuntos.find(f => f.NombreDocumento == fileList[i].name)) {
          setTimeout(() => {
            this.sharedFunctions.showMessage("Ya existe un archivo con ese nombre. Por favor modifique el nombre del archivo o elimine el ya adjuntado", "Error");
          }, 100);
          return false;
        }
      }

      if (fileList != null && fileList.length > 0) {
        this.isFileAttaching = true;
        this.gastoService.uploadAttachTemp(fileList).subscribe(data => {
          this.isFileAttaching = false;
          if (data != null && data.Success && data.Result != null && data.Result.Archivos != null && data.Result.Archivos.length > 0) {
            for (let i=0; i<data.Result.Archivos.length; i++) {
              if (data.Result.Archivos[i] != null) {
                this.item.Adjuntos.push(data.Result.Archivos[i]);
              }
            }
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando subir los archivos", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isFileAttaching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    }
  }
}
